// @flow

import Api from './ApiBase';

class PlaceApi extends Api {
  serializerType = 'places';

  get = async (id: number | string) => {
    const json = await this.request(`places/${id}`);
    const data = await this.deserialize(json);

    return { data, meta: json.meta };
  }
}

export default new PlaceApi();
